import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { CustomDatePickerComponent } from "./custom-date-picker.component";
import { InputModule } from "@airnauts/ng-components/input";

@NgModule({
  declarations: [CustomDatePickerComponent],
  imports: [
    MatFormFieldModule,
    MatInputModule,
    MatDatepickerModule,
    ReactiveFormsModule,
    InputModule,
  ],
  exports: [CustomDatePickerComponent],
})
export class CustomDatePickerModule { }
